/**
 * Pages that buyers, members or anyone can open without the creator
 * dashboard's auth: they skip getMe and never load Google Analytics.
 */
export function isPublicPath(pathname: string): boolean {
  return (
    pathname.startsWith('/experiences/') ||
    pathname.includes('/buy/') ||
    pathname.startsWith('/g/') ||
    pathname.startsWith('/p/') ||
    pathname.includes('/thank-you') ||
    pathname === '/privacy' ||
    pathname === '/terms'
  );
}
